import { resetAll } from '@wwt/shared/utils'

export const useLogOut = () => {
	return {
		handleSelect: resetAll
	}
}
